<template>
  <el-dialog
    title="Vevői megrendelés létrehozása"
    :visible="true"
    width="500px"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      ref="customerOrderForm"
      :model="formData"
      :rules="rules"
      label-position="top"
      v-loading="loading"
      @submit.native.prevent="save"
    >
      <el-form-item
        prop="partner"
        label="Vevő"
      >
        <el-select
          v-model="formData.partner"
          filterable
          remote
          :remote-method="searchPartners"
          :loading="partnerLoading"
          placeholder="Írd be a partner nevét a kereséshez..."
          style="width: 100%;"
          value-key="id"
        >
          <el-option
            v-for="partner in partners"
            :key="partner.id + 'partner'"
            :value="partner"
            :label="`#${partner.id} ${partner.company.name}`"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="save"
        :loading="buttonLoading"
      >
        Mentés
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    inwardHandlingId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      buttonLoading: false,
      partnerLoading: false,
      partners: [],
      formData: {
        partner: null
      },
      rules: {
        partner: [
          { required: true, message: 'Vevő kiválasztása kötelező', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    async searchPartners(query) {
      this.partnerLoading = true;
      if (!query) {
        this.partners = [];
      } else {
        const queryString = new URLSearchParams({
          name: query,
        });
        this.partners = await this.$store.dispatch('partner/search', '?' + queryString.toString());
      }
      this.partnerLoading = false;
    },
    async save() {
      try {
        await this.$refs.customerOrderForm.validate();
        
        this.buttonLoading = true;
        
        await this.$store.dispatch('inwardHandling/createCustomerOrder', {
          inwardHandlingId: this.inwardHandlingId,
          partner_id: this.formData.partner.id
        });
        
        this.handleClose();
        
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          this.$message.error(e.response.data.message);
        } else if (e.message) {
          this.$message.error(e.message);
        }
      } finally {
        this.buttonLoading = false;
      }
    }
  }
};
</script>
